import Contact from '../pages/contacts';

const App = () => <Contact />;

export default App;
